var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefuseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.89,
    height: 15.89,
    viewBox: "0 0 15.89 15.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M21.113,19.234l5.675-5.677a1.33,1.33,0,1,0-1.881-1.881l-5.675,5.677-5.675-5.677a1.33,1.33,0,1,0-1.881,1.881l5.675,5.677L11.676,24.91a1.33,1.33,0,0,0,1.881,1.881l5.675-5.677,5.675,5.677a1.33,1.33,0,0,0,1.881-1.881Z",
    transform: "translate(-11.285 -11.289)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefuseIcon);
export default __webpack_public_path__ + "static/media/refuseIcon.319124a1ef7109809cdb82a8d20d581d.svg";
export { ForwardRef as ReactComponent };